// extracted by mini-css-extract-plugin
export default {"svg_path_stroke_black":"RouteLayersPopoverContent_svg_path_stroke_black__8u7d8","svg_path_stroke_white":"RouteLayersPopoverContent_svg_path_stroke_white__mesz5"};